/**
 * Title management utilities
 * Ensures all page titles follow the "RUKH ERP — [Page Title]" format
 */

/**
 * Formats a page title with the RUKH ERP prefix
 * @param title - The page title (without prefix)
 * @returns Formatted title: "RUKH ERP — [title]"
 */
export function formatPageTitle(title: string): string {
  if (!title || title.trim() === '') {
    return 'RUKH ERP'
  }
  
  // Remove any existing prefix to avoid duplication
  const cleanTitle = title.replace(/^RUKH ERP\s*[—-]\s*/i, '').trim()
  
  return `RUKH ERP — ${cleanTitle}`
}

/**
 * Sets the document title
 * @param title - The page title (will be formatted with prefix)
 */
export function setDocumentTitle(title: string): void {
  document.title = formatPageTitle(title)
}

/**
 * Format route name as readable title
 * Example: "CRMAccounts" → "CRM Accounts"
 * @param name - Route name
 * @returns Formatted title
 */
export function formatRouteName(name: string): string {
  return name
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

